import { useEffect, useState } from "react";
import auth from "../services/auth";
import Constants from "expo-constants";
import { setUserProfile } from "app/modules/login/reducer/actions";
import { useDispatch } from "react-redux";

export default function useLogin() {
  const [isAuth, setIsAuth] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${Constants.manifest?.extra?.KEYCLOAK_URL}/auth/js/keycloak.js`;
    script.setAttribute("rel", "preconnect");
    document.body.appendChild(script);
    script.onload = async () => {
      const isAuthentication = await auth.login();
      const loadProfile = await auth.loadProfile();
      if (isAuthentication) {
        setIsAuth(true);
        dispatch(setUserProfile(loadProfile));
      }
    };
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return isAuth;
}
